import { Link, type LinkProps } from "react-router-dom"
import { useHaptic } from "@/shared/hooks/use-haptic"

export function HapticLink({ onClick, ...props }: LinkProps) {
	const { triggerHaptic } = useHaptic()

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		triggerHaptic("light")
		onClick?.(e)
	}

	return <Link onClick={handleClick} {...props} />
}
